import { AfterViewInit, Component, Input, NgZone, OnChanges, OnInit, SimpleChanges, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import * as d3 from 'd3';
import { D3, D3Service, Selection } from 'd3-ng2-service';
import { DataService } from './data.service';
import { CategoryAnalytic, UserAnalytic } from '../../model/admin-graph-analytic';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [D3Service, DataService]
})
export class PieChartComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() chartTitle;
  @Input() $pieData: Observable<CategoryAnalytic | UserAnalytic>;
  @Input() statusPieSvgContainerId;
  private pieData: any=[];

  public d3: D3;
  public d3Svg: Selection<SVGSVGElement, any, null, undefined>;
  private svgContainer: any;
  private statusPercentageValue = null;
  private statusValue = null;
  private pieStatusPercentText: any;
  private arcPath: any;
  ystPath;
  @Output() studentDetail = new EventEmitter();
  @Output() courseDetail = new EventEmitter();
  public parentNode;
  public ystArcData;
  public inProgressArcData;
  public completedArcData;
  coPath;
  ipPath;
  public noData;
  constructor(private zone: NgZone,
    private router:Router,
     private d3Service: D3Service,
     private dataService: DataService) {

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.createD3Instance();
    this.getChartData().then((data) => {
        this.zone.runOutsideAngular(() => {
          this.createPieChart(data);
        });
    });
  }


  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    // if (changes['pieData']) {
    //   this.createPieChart(this.pieData);
    //   // this.groupPosts = this.groupByCategory(this.data);
    // }
  }

  private async getChartData() {
    return await new Promise((resolve, reject) => {
      // get the data and resolve;
      this.$pieData.subscribe(res => {
        if(res!=null){
          this.pieData = res.analyticsStatus;
          if(this.pieData!=undefined){
            if(this.pieData[0].percentage==0 && this.pieData[1].percentage==0 && this.pieData[2].percentage==0){
              this.noData=true;
            }
            else{
              this.noData=false;
            }
          }
        }else{
          this.noData=true;
        }
        this.dataService.graphData = this.pieData;
      });
      setTimeout(() => {
        if (this.dataService.graphData) {
          resolve(this.dataService.graphData);
        } else {
          reject('No Data available');
        }
      }, 2000);
    });
  }

  /**
   @description Method to initiate d3 instance;
   */
  private createD3Instance() {
    // this.data = this.dataService.graphData;
    this.d3 = this.d3Service.getD3();
  }

  public createPieChart(data) {
    var tempThis = this;
    const containerLayout = this.calculateContainerLayout();
    const self = this;
    const _d3 = self.d3;
    let path;
    /** @description  - arc is the configuration of the (donut | pie) arc path */
    const arc: any = d3.arc()
      .innerRadius(containerLayout.radius - 27)
      .outerRadius(containerLayout.radius - 5)
      .cornerRadius(2)
      .padAngle(0.045)
      .padRadius(containerLayout.radius)
      ;
    const arcLarge: any = d3.arc()
      .innerRadius(containerLayout.radius - 35)
      .outerRadius(containerLayout.radius)
      .cornerRadius(4)
      .padAngle(0.055)
      .padRadius(containerLayout.radius)
      ;

    const pie = () => this.createPie();
    const svg = this.getSvg(containerLayout);
    const inActivateState = function (p) {

      _d3.selectAll('path').attr('d', arc);
    };
    const toggleArc = function (p) {
      console.log('toggleArc called........');
      p.state = !p.state;
      // reset the text to empty string.
      d3.selectAll('circle').remove();
      d3.selectAll('line').remove();
      d3.selectAll('text').text('');
      // p.state ? self.onClickArc(p) : (self.statusPercentageValue = null, self.statusValue = null);
      self.onClickArc(p);
      // alert(self);
      const dest = p.state ? arcLarge : arc;
      // to retain the arc in the default state.
      const activeArc = d3.select(this)
        .transition()
        .attr('d', dest)
        ;
      const centroid = arcLarge.centroid(p);
      // console.log('Center of the Arc', centroid);
      const dotColor = '#4a4a4a45';
      const arcDot = d3.select(this.parentNode)
        // .transition()
        .append('circle')// attach a circle
        .attr('cx', centroid[0]) // position the x-center
        .attr('cy', centroid[1])// position the y-center.attr("r",50);
        .attr('r', 3)
        .attr('fill', dotColor)
        .attr('class', 'activeArc')
        ;
      const x1: number = parseInt(arcDot.attr('cx'), 10);
      const y1 = parseInt(arcDot.attr('cy'), 10);
      const x2 = x1 / 2;
      const y2 = y1 / 2;
      //  const lineColor = d3.select(this).attr('fill');
      d3.select(this.parentNode).append('line').attr('x1', x1).attr('y1', y1)
        .attr('x2', x2).attr('y2', y2)
        // .attr('fill', lineColor)
        .style('stroke', dotColor)
        .style('stroke-width', 2)
        ;

      p.state = false;
    };
    this.d3Svg = svg;
    let group;
    (() => group = this.setSvgLayout(svg))();
    // console.log('--------------------------pie data is created--------------------------');
    const setPath = () => path = group
      .datum(data)
      .selectAll('.arc')
      // .selectAll('path')
      .data(pie())
      .enter()
      .append('g')
      .on('click', inActivateState)
      .attr('id', () => data.id)
      .attr('name', () => 'innerValue')
      .append('path')
      .attr('fill', function (d, i: any) {
        let colorCode = '';
        d.data['status'] === 'In Progress' ? colorCode = '#fd9a2e' :
          d.data['status'] === 'Completed' ? colorCode = '#58c32d' :
            colorCode = '#f75253';
        return colorCode;
      },
      )
      .attr('d', arc)
      .style('cursor', 'pointer')
      .on('click', toggleArc)

      ;
    group = this.setSvgLayout(svg);

    var arcs = setPath();
    var arcsGroup = JSON.stringify(arcs)
    var parentGroup = JSON.parse(arcsGroup)._groups[0]
    var ystArc = parentGroup[0];
    var ystArcString = JSON.stringify(ystArc);
    this.ystArcData = JSON.parse(ystArcString).__data__;

    var inProgressArc = parentGroup[2];
    var inProgressArcString = JSON.stringify(inProgressArc);
    this.inProgressArcData = JSON.parse(inProgressArcString).__data__;

    var completedArc = parentGroup[1];
    var completedArcString = JSON.stringify(completedArc);
    this.completedArcData = JSON.parse(completedArcString).__data__;

    this.ystPath = arcs._groups[0][0];
    this.coPath = arcs._groups[0][1];
    this.ipPath = arcs._groups[0][2];
    if (this.statusPieSvgContainerId == 'studentPieContainer') {
      if(this.ystArcData.data.percentage!=0){
        this.toggleArc(this.ystArcData, this.ystPath);
      }
      else if(this.inProgressArcData.data.percentage!=0){
        this.toggleArc(this.inProgressArcData, this.ipPath);
      }
      else{
        this.toggleArc(this.completedArcData, this.coPath);
      }
    }



    window.addEventListener('resize', () => {
      group = this.setSvgLayout(svg);
      setPath();
      this.arcPath = setPath;
    });
  }

  public toggleArc(p, path) {
    const self = this;
    const _d3 = self.d3;
    const containerLayout = this.calculateContainerLayout();
    const arc: any = d3.arc()
      .innerRadius(containerLayout.radius - 27)
      .outerRadius(containerLayout.radius - 5)
      .cornerRadius(2)
      .padAngle(0.045)
      .padRadius(containerLayout.radius)
      ;
    const arcLarge: any = d3.arc()
      .innerRadius(containerLayout.radius - 35)
      .outerRadius(containerLayout.radius)
      .cornerRadius(4)
      .padAngle(0.055)
      .padRadius(containerLayout.radius)
      ;
    console.log('toggleArc code started.......called........');
    p.state = !p.state;
    // reset the text to empty string.
    d3.selectAll('circle').remove();
    d3.selectAll('line').remove();
    d3.selectAll('text').text('');
    // p.state ? self.onClickArc(p) : (self.statusPercentageValue = null, self.statusValue = null);
    self.onClickArc(p);
    // alert(self);
    const dest = p.state ? arcLarge : arc;
    // to retain the arc in the default state.
    const activeArc = d3.select(path)
      .transition()
      .attr('d', dest)
      ;
    const centroid = arcLarge.centroid(p);
    // console.log('Center of the Arc', centroid);
    const dotColor = '#4a4a4a45';
    // console.log('dotColor', dotColor);
    const arcDot = d3.select(path.parentNode)
      // .transition()
      .append('circle')// attach a circle
      .attr('cx', centroid[0]) // position the x-center
      .attr('cy', centroid[1])// position the y-center.attr("r",50);
      .attr('r', 3)
      .attr('fill', dotColor)
      .attr('class', 'activeArc')
      ;
    const x1: number = parseInt(arcDot.attr('cx'), 10);
    const y1 = parseInt(arcDot.attr('cy'), 10);
    const x2 = x1 / 2;
    const y2 = y1 / 2;
    // console.log('x1.....' + x1 + 'x2..........' + x2 + 'y1.........' + y1 + '...y2..........' + y2)
    //  const lineColor = d3.select(this).attr('fill');
    d3.select(path.parentNode).append('line').attr('x1', x1).attr('y1', y1)
      .attr('x2', x2).attr('y2', y2)
      // .attr('fill', lineColor)
      .style('stroke', dotColor)
      .style('stroke-width', 2)
      ;

    p.state = false;
    this.inActivateState(p, arc, d3);
  };

  inActivateState(p, arc, d3) {

    d3.selectAll('path').attr('d', arc);
  };


  public onClickArc(pieData) {
    this.courseDetail.emit(pieData);
    this.studentDetail.emit(pieData);
    if (pieData['state']) {
      this.displayStatusLabel(pieData);
      /* pass the data to other component via event  emitter*/
      // console.log(pieData['data']);
    }
  }

  private displayStatusLabel(pieData?) {
    if (pieData) {
      this.statusPercentageValue = pieData['data']['percentage'];
      this.statusValue = pieData['data']['status'];
      this.pieStatusPercentText.text(`${this.statusPercentageValue}%`);
      // .attr('class', 'arc-percentage-symbol');
    } else {
      this.statusPercentageValue = '';
      this.statusValue = '';
      this.pieStatusPercentText.text(``);
    }
    const statusName = this.pieStatusPercentText.append('tspan').attr('x', 5).attr('y', 15).attr('class', 'arc-status-name');
    statusName.text(`${this.statusValue}`);
  }

  private calculateContainerLayout() {
    if(this.router.url=='/admin/dashboard'){
    const container = this.d3.selectAll(`#${this.statusPieSvgContainerId}`);
    if(container.style){
      const width = parseFloat(container.style('width'));
      const height = parseFloat(container.style('height'));
      const radius = Math.min(width, height) / 2;
      // console.log('container width...hi.......' + width + 'height' + height);
      return { container: container, width: 250, height: 153.75, radius: 91.875 };
    }
  }
  }

  private getSvg({ container }) {
    this.svgContainer = container.selectAll('svg');

    return this.svgContainer;
  }

  private createPie() {
    // let data;
    // this.data.length > 0 ? data = this.data : data = null;
    const pie = this.d3.pie();
    const data = this.dataService.graphData;
    // console.log('====> ', data);
    return pie.value((d, i) => {
      // console.log('========> ', d, i);
      return d['percentage'];
    })
      .sort(null);
  }

  private setSvgLayout(svgNode) {
    if(this.router.url=='/admin/dashboard'){this.svgContainer.selectAll('g').remove();
    const containerLayout = this.calculateContainerLayout();
    const margin = { top: 20, right: 10, bottom: 20, left: 10 };
    const svgWidth = containerLayout.width - (margin.right + margin.left);
    const svgHeight = containerLayout.height - (margin.top + margin.bottom);
    // const percentageTextPositionX = (containerLayout.radius - svgWidth) / 4;
    const percentageTextPositionX = (containerLayout.radius / svgWidth) - 29;
    const percentageTextPositionY = (containerLayout.radius / svgHeight) + 10;


    const pieG = svgNode.attr('width', svgWidth).attr('height', svgWidth)
      .append('g')
      .attr('transform', 'translate(' + 247 / 2 + ',' + ((242 / 2)) + ')');
    // .selectAll('tspan')a
    this.pieStatusPercentText = pieG.append('text').attr('id', 'percent-text')
      .text(() => {
        return this.statusPercentageValue ? `${this.statusPercentageValue}%` : '';
      })
      .attr('transform', `translate( ${percentageTextPositionX}, ${percentageTextPositionY} )`)
      .attr('class', 'arc-percentage-value');
    this.pieStatusPercentText.append('tspan').text(this.statusValue)
      .attr('class', 'arc-status-name').attr('x', 5).attr('y', 15);
    return pieG;}
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/dashboard/graph/pie-chart/pie-chart.component.ts